import React, { Component } from 'react';
import { Loader } from './index';
import styled from 'styled-components';

import facebookIcon from '../../assets/images/facebook-icon.png';
import instagramIcon from '../../assets/images/instagram-icon.png';
import camera from '../../assets/images/camera-icon.png';
import heart from '../../assets/images/heart-icon.png';
import arrowRight from '../../assets/images/arrow-right-icon.png';

type Props = {
  image: any,
  authorImage: any,
  description: string,
  author: string,
  link: string,
  subStr: Function
};

type State = {
  loading: boolean
};

const InstagramDM = styled.div`
  margin-right: 30px;
  min-width: 250px;
`;
const Container = styled.a`
  float: left;
  max-width: 250px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #ddd;
  margin: 5px 0;
  text-decoration: none;
`;
const Image = styled.img`max-width: 248px;`;
const LogoCamera = styled.img`
  max-width: 16px;
  margin-right: 5px;
`;
const LogoHeart = styled.img`
  max-width: 16px;
  margin-right: 5px;
`;
const LogoContainer = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
`;
const DataContainer = styled.div`margin: 0;`;
const ActionsContainer = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  padding: 10px;
`;
const FBData = styled.div`position: relative;`;
const ResponseText = styled.span`
  color: #111;
  font-size: 12px;
  margin: 0;
  font-weight: bold;
`;

const ProfileContainer = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  padding: 10px;
`;
const ProfileImage = styled.img`
  max-width: 28px;
  border: 1px solid #ddd;
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  border-radius: 40px;
  margin-right: 10px;
`;
const ProfileName = styled.p`
  flex: 1;
  color: #111;
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  text-align: left;
`;
const Arrow = styled.img`max-width: 24px;`;
const Caption = styled.div`
  border-bottom: 1px solid #ddd;
  padding: 3px 12px 8px;
  text-align: left;
`;
const CaptionUser = styled.span`
  color: #111;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
`;
const CaptionTag = styled.span`
  font-size: 12px;
  color: #444;
  text-decoration: none;
  text-align: left;
`;
const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
const Logo = styled.img`height: 24px;`;
const Sum = styled.span`
  font-size: 24px;
  color: #aaa;
  margin: 0 10px;
  font-weight: bold;
`;

class InstagramDMComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2500);
  }

  renderContent = () => {
    const { image, description, author, authorImage, link, subStr, facebook } = this.props;

    if (this.state.loading) {
      return <Loader inverted active />;
    }

    return (
      <Container href={link} target="_blank">
        <ProfileContainer>
          {!facebook && <ProfileImage src={authorImage} alt={author} />}
          <ProfileName>{author}</ProfileName>
          {!facebook && <Arrow src={arrowRight} alt={author} />}
        </ProfileContainer>
        <Image src={image} alt={subStr(description)} />
        <FBData className="instagramDM-data">
          <DataContainer>
            <Caption>
              {author.length > 0 && (
                <span>
                  <CaptionUser>{author}</CaptionUser>
                  {` `}
                </span>
              )}
              {<CaptionTag href={link}>{subStr(description, 55)}</CaptionTag>}
            </Caption>
            <ActionsContainer>
              <LogoHeart src={heart} />
              <LogoContainer>
                <LogoCamera src={camera} />
                <ResponseText>Reply</ResponseText>
              </LogoContainer>
            </ActionsContainer>
          </DataContainer>
        </FBData>
      </Container>
    );
  };

  renderSource = () => {
    if (this.props.facebook) {
      return <Logo src={facebookIcon} alt="Facebook" />;
    }

    return <Logo src={instagramIcon} alt="Instagram" />;
  };

  render() {
    return (
      <div>
        <h4 className="preview-title">Instagram DM</h4>
        <LogosContainer>
          {this.renderSource()}
          <Sum>+</Sum>
          <Logo src={instagramIcon} alt="Instagram" />
        </LogosContainer>

        <InstagramDM className="preview-container">
          {this.renderContent()}
          <div className="clearfix" />
        </InstagramDM>
      </div>
    );
  }
}

export default InstagramDMComponent;



// WEBPACK FOOTER //
// ./src/components/share/InstagramDM.js